export default __webpack_public_path__ + "static/media/background.89f53a41.jpg";